import React from "react";
//#region types
import { SimpleAccordionTableRowProps } from "models/propTypes/simpleTableProps";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { TableCell, TableRow } from "@mui/material";
import { Icon, SimpleTooltip } from "components/common";
import SimpleAccordionTableRowContent from "./content";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const SimpleAccordionTableRow: React.FC<SimpleAccordionTableRowProps> = ({
  title,
  value,
  subContent,
  tooltip,
  variant,
  emphasisValue,
  defaultExpanded,
}) => {
  const [expanded, setExpanded] = React.useState<boolean>(defaultExpanded ?? false);

  const toggleExpansion = () => setExpanded(!expanded);

  const isExpandable = subContent && subContent.length > 0;
  const isPrimary = variant === "primary";

  return (
    <>
      <TableRow
        className={clsx(cssExports.simpleAccordionTableRow, cssExports.expandable, isPrimary && cssExports.primary)}
        onClick={isExpandable ? toggleExpansion : undefined}
      >
        {isExpandable ? (
          <TableCell className={clsx(cssExports.tableCell, cssExports.expandableCell)}>
            {expanded ? (
              <Icon icon={IconDefinitionConstants.WChevronSmallDown} />
            ) : (
              <Icon icon={IconDefinitionConstants.WChevronSmallRight} />
            )}
          </TableCell>
        ) : (
          <></>
        )}

        <TableCell colSpan={isExpandable ? 1 : 2} className={clsx(cssExports.tableCell, cssExports.titleCell)}>
          <span>
            {title}
            {tooltip ? (
              <SimpleTooltip text={tooltip} placement="right">
                <span>
                  <Icon icon={IconDefinitionConstants.WInfo} className={cssExports.tooltipIcon} />
                </span>
              </SimpleTooltip>
            ) : (
              <></>
            )}
          </span>
        </TableCell>
        <TableCell
          className={clsx(
            cssExports.tableCell,
            cssExports.valueCell,
            isPrimary && emphasisValue && cssExports.emphasisValue
          )}
        >
          {value}
        </TableCell>
      </TableRow>
      {expanded ? <SimpleAccordionTableRowContent subContent={subContent} /> : <></>}
    </>
  );
};

export default SimpleAccordionTableRow;
